export default __webpack_public_path__ + "assets/d69b2f2bd7171aca062a47da96331cc9.png";